// Events
document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.modal-gallery').forEach(function (modalGallery) {

        const modalHasSwiper = modalGallery.querySelector('.swiper-container');

        if (modalHasSwiper) {

            // Open slider
            modalGallery.querySelectorAll('.gallery-grid [data-in-section]').forEach(button => {
                button.addEventListener('click', function(event) {
                    modalGallery.dataset.galleryDisplay = "zoom";
                    modalGallery.setAttribute("data-gallery-display", "zoom");
                    // jump into slider
                    const jump = parseInt(this.dataset.num, 10);
                    const swiperContainer = modalGallery.querySelector('.swiper-container');
                    const swiperInstance = swiperContainer.swiper;
                    if(swiperInstance && typeof jump === 'number') {
                        swiperInstance.slideTo(jump);
                    }
                });
            });

            // Filter picture by nav link
            modalGallery.querySelectorAll('.modal-gallery .gallery-nav .breadcrumb-link').forEach(links => {
                links.addEventListener('click', function(event) {
                    const filter = this.dataset.section;
                    modalGallery.dataset.gallerySection = filter;
                    modalGallery.setAttribute("data-gallery-section", filter);
                });
            });

            // Close Modal o Display picture in grid view
            let btnCloseModal = modalGallery.querySelector('.btn-close');
            if(btnCloseModal) {
                btnCloseModal.addEventListener('click', (event) => {
                    event.preventDefault();
                    let modalGalleryState = modalGallery.getAttribute('data-gallery-display') || 'grid';

                    if (modalGalleryState === 'grid') {
                        let modalInstance = window.Modal.getOrCreateInstance(modalGallery);
                        modalInstance.hide();
                    } else {
                        modalGallery.setAttribute("data-gallery-display", "grid");
                    }
                });
            }

        };

    });

});
